<div class="h-full overflow-y-auto">
  <div class="flex justify-end">
  <div class="my-1">
    <input
      type="text"
      name="time"
      id="time"
      [(ngModel)]="todayDate"
      [owlDateTime]="date"
      [owlDateTimeTrigger]="date"
      [selectMode]="'range'" [readOnly]="true" />
    <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange($event)" #date></owl-date-time>
  </div>
</div>

<div class="grid grid-cols-2 gap-4 ">
  <!-- Bar Chart -->
  <div class="bg-white p-2 rounded-md h-[400px]">
    <app-graph
      [chartData]="companyBarChartData"
      [chartOptions]="companyBarChartOptions"
      chartType="bar">
    </app-graph>
  </div>

  <!-- Pie Chart -->
  <div class="bg-white p-2 rounded-md h-[400px]">
   <div class="flex items-center justify-center">
     <app-graph
      [chartData]="companyPieChartData"
      [chartOptions]="companyPieChartOptions"
      chartType="pie">
    </app-graph>
   </div>
  </div>

  <!-- doughnut -->
  <div class="flex justify-center items-center bg-white p-2 rounded-md h-[400px]">
   <div class="">
     <app-graph
      [chartData]="doughnutChartData"
      [chartOptions]="doughnutChartOptions"
      chartType="doughnut">
    </app-graph>
   </div>
  </div>

  <!-- radar -->
  <div class="flex justify-center items-center bg-white p-2 rounded-md h-[400px]">
    <app-graph
      [chartData]="radarChartData"
      [chartOptions]="radarChartOptions"
      chartType="radar">
    </app-graph>
  </div>
</div>

</div>